export default __webpack_public_path__ + "assets/webgl/complete-18.5e5091d3.jpg";